import { Button, Stack, styled, Typography } from '@mui/material';
import { HeaderClient } from '../../elements/HeaderClient';
import React from 'react';
import { useInjection } from './hook';
import { TableInfiniteScroll } from 'app/components/elements/TableInfiniteScroll';
import { Location, SearchType } from 'types/loctions';
import { TextEllipsis } from '../../../../../components/elements/TextEllipsis';
import {
  isRoomLocationLevel,
  isVerticalLocationLevel,
  renderTitle
} from 'utils/renderTitleLocation';
import { InputSelect } from '../../../../../components/elements/InputSelect';

const optionSearchType = [
  { label: 'Partial Text', value: 'partial-text' },
  { label: 'Full text', value: 'full-text' }
];
export const FloorPlanLocationPage = () => {
  const {
    locations,
    fetchMoreData,
    hasMore,
    handleSearch,
    onSortHeader,
    searchParams,
    handleBack,
    paths,
    onClickAction,
    clientId,
    clientName,
    title,
    header,
    pathLastRoom,
    isFreeSearch,
    listButton,
    handleNavigateLastRoom,
    searchType,
    setSearchType
  } = useInjection();
  const renderDataMap = (locations: Location[]) => {
    return locations?.map((location) => {
      const isVerticalLevel = isVerticalLocationLevel(location.level);
      const isRoomLevel = isRoomLocationLevel(location.level);
      return {
        name: {
          value: (
            <TextEllipsis
              onClick={() => {
                isVerticalLevel &&
                  isRoomLevel &&
                  onClickAction({
                    href: `/pdfmapping/uploadplan/${clientName}/${clientId}/location/${location.id}`,
                    path: location.name,
                    locationId: location.id
                  });
              }}
              text={
                isFreeSearch
                  ? `${location.name} - ${renderTitle(location.level).title}`
                  : location.name
              }
              styles={{ textDecoration: 'underline', cursor: 'pointer', color: '#226AAA' }}
              width={'80%'}
            />
          )
        },
        actions: {
          value: isVerticalLevel ? (
            <Stack flexDirection="row" gap={1}>
              <Button
                onClick={() => {
                  onClickAction({
                    href: `/pdfmapping/uploadplan/${clientName}/${clientId}/location/${location.id}`,
                    path: location.name,
                    locationId: location.id
                  });
                }}>
                <Typography sx={{ textDecoration: 'underline', cursor: 'pointer' }}>
                  View Room
                </Typography>
              </Button>

              <Button
                onClick={() => {
                  onClickAction({
                    href: `/pdfmapping/uploadplan/${clientName}/${clientId}/location/${location.id}/plans`,
                    path: location.name,
                    locationId: location.id
                  });
                }}>
                <Typography sx={{ textDecoration: 'underline', cursor: 'pointer' }}>
                  View Plans
                </Typography>
              </Button>
            </Stack>
          ) : isRoomLevel ? (
            <Stack flexDirection="row" gap={1}>
              <Button
                onClick={() => {
                  onClickAction({
                    href: `/pdfmapping/uploadplan/${clientName}/${clientId}/location/${location.id}/plans`,
                    path: location.name,
                    locationId: location.id
                  });
                }}>
                <Typography sx={{ textDecoration: 'underline', cursor: 'pointer' }}>
                  View Plans
                </Typography>
              </Button>
            </Stack>
          ) : (
            <Stack flexDirection="row" gap={1}>
              <Button
                onClick={() => {
                  onClickAction({
                    href: `/pdfmapping/uploadplan/${clientName}/${clientId}/location/${location.id}`,
                    path: location.name,
                    locationId: location.id
                  });
                }}>
                <Typography sx={{ textDecoration: 'underline', cursor: 'pointer' }}>
                  View
                </Typography>
              </Button>
            </Stack>
          )
        }
      };
    });
  };
  return (
    <WrapperCreatePage>
      <HeaderClient
        onShowLastRoom={pathLastRoom ? handleNavigateLastRoom : undefined}
        buttons={listButton}
        title={title.title}
        // valueFilterType={searchParams.get('type') || ''}
        onSearch={handleSearch}
        searchholder="Search"
        // onFilterType={filterByTypeAccess}
        // onFilterClient={() => {}}
        // optionFilterClient={optionTypeAccess}
        // optionFilterType={optionTypeAccess}
        textButton={'Back'}
        isSearch={isFreeSearch}
        onClickButton={handleBack}
        paths={paths}
      />
      <Stack style={{ width: 'fit-content', gap: '8px' }}>
        <Typography
          style={{
            fontWeight: '700',
            color: '#226AAA',
            whiteSpace: 'nowrap'
          }}>
          Search Type
        </Typography>
        <InputSelect
          style={{ minHeight: 'auto', height: '48px' }}
          value={searchType}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onChange={(e: any) => setSearchType(e.target.value as SearchType)}
          options={optionSearchType}
        />
      </Stack>
      <Stack id={'id-table-clients'} sx={{ height: 'calc(100% - 230px)', overflow: 'scroll' }}>
        <TableInfiniteScroll
          sort={{
            field: searchParams.get('sortBy') || '',
            order: searchParams.get('order') || ''
          }}
          onSortHeader={onSortHeader}
          idElementScroll={'id-table-clients'}
          data={renderDataMap(locations)}
          handleFetchMore={fetchMoreData}
          headers={header}
          hasMore={hasMore}
          handleChooseRow={() => {}}
          styledTableRow={{ cursor: ' default ' }}
        />
      </Stack>
    </WrapperCreatePage>
  );
};

const WrapperCreatePage = styled(Stack)(() => ({
  padding: '40px 30px 30px 40px',
  width: '100%',
  height: '100vh',
  gap: '20px'
}));
